<template>
  <div class="d-flex align-center flex-column overflow-hidden">
    <!--    <v-chip class="mr-3 accent white&#45;&#45;text op-text" v-if="dutyTime">{{ dutyTime }}</v-chip>-->
    <!--    <v-chip class="mr-3 grey darken-1 white&#45;&#45;text op-text" v-if="locationFromTo"> {{ locationFromTo }}</v-chip> -->
    <div class="d-flex flex-nowrap text-no-wrap caption" v-if="dutyTime">{{ dutyTime }}</div>
    <div class="d-flex flex-nowrap text-no-wrap caption" v-if="showDutyCalendarLocation && locationFromTo">{{ locationFromTo }}</div>
    <div class="d-flex text-center caption" style="font-size: 0.6rem !important" v-for="(c, ind) in vehicleLocation" :key="ind">{{ c }}</div>
  </div>
</template>

<script>
import tenantStrategies from '../dutyActivities/tenantStrategies';
import dutyMixin from '@/modules/myDuties/common/dutyMixin';
import commonMixin from '@/mixins/common';

export default {
  name: 'DutyCardContent',
  mixins: [dutyMixin, commonMixin],
  props: {
    duty: Object,
    dutyActivities: Array,
    tenant: String,
    showDutyCalendarLocation: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    /**
     * Get first activity whose blockcode is not null
     */
    firstActivity() {
      return tenantStrategies.getFirstActivity({ moduleConfig: this.mx_moduleConfig, tenant: this.tenant, dutyActivities: this.dutyActivities });
    },
    lastActivity() {
      return tenantStrategies.getLastActivity({ moduleConfig: this.mx_moduleConfig, tenant: this.tenant, dutyActivities: this.dutyActivities });
    },
    locationFromTo() {
      const da = this.dutyActivities;
      if (da && da.length > 0 && this.firstActivity) {
        let start = this.firstActivity._startStop ? this.firstActivity._startStop.shortname : '';
        let lastDa = this.lastActivity;
        let end = lastDa._endStop ? lastDa._endStop.shortname : '';
        if (start && end) return `${start} - ${end}`;
      }
      return null;
    },
    dutyTime() {
      let time = '';
      if (this.firstActivity && this.firstActivity.fromMinutesAfterMidnight)
        time += this.mx_time(this.firstActivity.fromMinutesAfterMidnight, this.firstActivity) + ' - ';
      if (this.lastActivity && this.lastActivity.toMinutesAfterMidnight) time += this.mx_time(this.lastActivity.toMinutesAfterMidnight, this.lastActivity);
      return time;
    },
    vehicleLocation() {
      return this.dutyActivities
        .filter((da) => da.fzgStandplatz || da.fzgStandplatz)
        .map((da) => `${da.fzgStandplatz}${da.fzgNummer ? ' / ' + da.fzgNummer : ''}`);
    },
  },
};
</script>
